//port of chatmeter/dashboard-play/ui/app/modules/listings/ListingService.js
import client from '../session/apiClient';
import presignedExport from "../auth/presignedExport";

export default {
  listingAccuracyReport: (groupId, params) => {
    return client.get('/dashboard/listingAccuracy/overview/' + groupId, {
      params
    }).then(resp => resp.data);
  },
  listingAccuracyReportByLocation: (groupId, params) => {
    return client.get('/dashboard/listingAccuracy/locations/' + groupId, { params }).then(resp => resp.data);
  },
  exportListingAccuracyReportByLocation: (groupId, params) => {
    // TODO: Fix bug with multiple providers not being properly comma-delimited.
    // E.g. it should be ?providers=A&providers=B&providers=C and NOT ?providers=A,B,C (this will make it an invalid provider and default to all providers)
    // https://gitlab.chatmeter.com/chatmeter/chatmeter/-/merge_requests/2985
    return presignedExport.downloadExport(`/dashboard/listingAccuracy/export/locations/${groupId}`, { ...params });
  },
  exportListingAccuracyReportByProvider: (groupId, params) => {
    // TODO: Fix bug with multiple providers not being properly comma-delimited. See comment in exportListingAccuracyReportByLocation
    return presignedExport.downloadExport(`/dashboard/listingAccuracy/export/providers/${groupId}`, { ...params });
  },
  snapshotSummary: (groupId) => {
    return client.get('/dashboard/listingSummary/group/' + groupId)
      .then(resp => resp.data)
      .catch(ex => { throw new Error("Error occurred while summary!") })
  },
  listingReportOld: (groupId, params) => {
    return client
      .get(`/dashboard/listingReport/${groupId}`, { params })
      .then(resp => {
        // var listingResult = new ListingResult();
        // listingResult.results = data;
        // listingResult.reportParams = {};
        // angular.copy(params, listingResult.reportParams);
        // listingResult.pendingResults = false;
        // deferred.resolve(listingResult);
        return resp.data;
      })
      .catch(ex => { throw new Error("Error occurred while summary!") });
  },
  //TODO - listingReport
  //TODO - export
  //TODO - listingReportDrillDown
  //TODO - listingFixedURLInfo
  getListing: (params) => {
    return client.get('/v5/listings', {params}).then(resp => resp.data);
  },
  removeListing: (listingId) => {
    return client.delete('/v5/listings/' + listingId);
  },
  markListingPrimary: (listingId) => {
    return client.post('/v5/listings/' + listingId + '/makePrimary', {reason: 'User updated'})
      .then(resp => resp.data);
  },
  pdateFixedURL: (createListing) => {
    return client.post('/v5/listings', createListing).then(resp => resp.data);
  },
  getRespondableListingIds: (groupId) => {
    return client.get('/v5/listings/respondableListingIds', {params: {'groupId': groupId}}).then(response => response.data);
  }
};
